/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindSpotlightsByOrganizationIdQueryResponse,
  FindSpotlightsByOrganizationIdPathParams,
} from "../types/FindSpotlightsByOrganizationId.ts"

export const findSpotlightsByOrganizationIdQueryKey = (
  organizationId: FindSpotlightsByOrganizationIdPathParams["organizationId"]
) =>
  [
    {
      url: "/v1/view/:organizationId/spotlights",
      params: { organizationId },
    },
  ] as const

export type FindSpotlightsByOrganizationIdQueryKey = ReturnType<
  typeof findSpotlightsByOrganizationIdQueryKey
>

/**
 * @summary Find spotlights by organization id
 * {@link /v1/view/:organizationId/spotlights}
 */
export async function findSpotlightsByOrganizationId(
  organizationId: FindSpotlightsByOrganizationIdPathParams["organizationId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindSpotlightsByOrganizationIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/view/${organizationId}/spotlights`,
    ...requestConfig,
  })
  return res
}

export function findSpotlightsByOrganizationIdQueryOptions(
  organizationId: FindSpotlightsByOrganizationIdPathParams["organizationId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findSpotlightsByOrganizationIdQueryKey(organizationId)
  return queryOptions<
    ResponseConfig<FindSpotlightsByOrganizationIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindSpotlightsByOrganizationIdQueryResponse>,
    typeof queryKey
  >({
    enabled: !!organizationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findSpotlightsByOrganizationId(organizationId, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find spotlights by organization id
 * {@link /v1/view/:organizationId/spotlights}
 */
export function useFindSpotlightsByOrganizationId<
  TData = ResponseConfig<FindSpotlightsByOrganizationIdQueryResponse>,
  TQueryData = ResponseConfig<FindSpotlightsByOrganizationIdQueryResponse>,
  TQueryKey extends QueryKey = FindSpotlightsByOrganizationIdQueryKey,
>(
  organizationId: FindSpotlightsByOrganizationIdPathParams["organizationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindSpotlightsByOrganizationIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findSpotlightsByOrganizationIdQueryKey(organizationId)

  const query = useQuery(
    {
      ...findSpotlightsByOrganizationIdQueryOptions(organizationId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
